export const blockIconsTravelDinnerDiningNew = (
	<span className='material-symbols-outlined'>dinner_dining</span>
);
